var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[(_vm.showShadow)?_c('div',{staticClass:"shadow-st"},[_c('div',{staticClass:"inner-text"},[_vm._v("*플랜 변경 후 이용 가능합니다.")])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }